import qqPluginClient from './qqPluginClient.js';
import {
  resolveRedirectOrBinaryMediaUrl,
  buildMediaSourceResult
} from './musicPluginProxy.js';

/**
 * 洛雪音乐「长青SVIP音源」脚本 - QQ音乐线路
 * 解析后端是裸IP(175.27.166.236) + HTTP，域名/协议与现有 qqPluginClient
 * (music.haitangw.cc, HTTPS) 完全不同，因此作为独立音源呈现。
 *
 * 注意：裸IP + HTTP 意味着没有域名信誉与TLS保护，若该IP将来变更或不可用，
 * 此音源会直接失败（不会影响其他音源）。
 */
const PLATFORM = 'lx-qq';
const SOURCE_TAG = 'lx-qq-plugin';

const LEVELS = {
  low: 'standard',
  standard: 'standard',
  high: 'exhigh',
  super: 'lossless'
};

const REQUEST_HEADERS = {
  Referer: 'https://y.qq.com/',
  'User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
};

async function search(query, page = 1, type = 'music') {
  const result = await qqPluginClient.search(query, page, type);
  return {
    ...result,
    data: result.data.map((song) => ({ ...song, source: SOURCE_TAG }))
  };
}

async function getMediaSource(musicItem, quality = 'high') {
  const songmid = musicItem?.songmid || musicItem?.mid || musicItem?.raw?.songmid || musicItem?.raw?.mid;
  if (!songmid) {
    throw new Error('QQ音乐歌曲ID（songmid）不能为空');
  }

  const level = LEVELS[quality] || LEVELS.high;
  const audioUrl = `http://175.27.166.236/kgqq1/qq.php?type=mp3&id=${songmid}&level=${level}`;

  try {
    const audioData = await resolveRedirectOrBinaryMediaUrl(audioUrl, REQUEST_HEADERS);
    return buildMediaSourceResult(audioData, musicItem, quality);
  } catch (primaryError) {
    console.warn('[lxQqPluginClient] 长青线路获取失败，回退官方QQ客户端:', primaryError.message);
    return qqPluginClient.getMediaSource(musicItem, quality);
  }
}

async function getLyric(musicItem, options = {}) {
  if (options.cachedLyric) {
    return options.cachedLyric;
  }

  try {
    const result = await getMediaSource(musicItem, 'high');
    if (result.lyric) {
      return result.lyric;
    }
  } catch (error) {
    console.warn('[lxQqPluginClient] 长青线路获取歌词失败，回退官方QQ音乐客户端:', error.message);
  }

  return qqPluginClient.getLyric(musicItem, options);
}

const lxQqPluginClient = {
  platform: PLATFORM,
  version: '1.2.0',
  search,
  getMediaSource,
  getLyric
};

export default lxQqPluginClient;
